export const getObjectMask = obj => {
  if (!obj.clipId) {
    return;
  }
  return obj.canvas.getObjects().find(o => o.id === obj.clipId);
}

export const getMinScaleForMaskedObject = (obj, mask) => {
  const maskObj = mask ? mask : getObjectMask(obj);
  if (!maskObj) {
    return;
  }
  const bounds = maskObj.getBoundingRect(true, true);
  const xK = bounds.width / obj.width;
  const yK = bounds.height / obj.height;
  return xK > yK ? xK : yK;
}


export const getMaxScale = (obj) => {
  const canvas = obj.canvas;
  if (!canvas) {
    return;
  }
  const { minDPI } = canvas.settings;
  if (minDPI) {
    const mmInInch = 1 / 25.4;
    const actualPixelWidth = obj.size.width;
    return actualPixelWidth / (minDPI * obj.width * mmInInch);
  }
}
